// eslint-disable-next-line import/prefer-default-export
export const valueFromObject = (key, obj) => key.split('.').reduce((reduced, index) => reduced[index], obj);
//# sourceMappingURL=valueFromObject.js.map